/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as PublicBetaClosedRouteImport } from './routes/_public.beta-closed'
import { Route as PublicForbiddenRouteImport } from './routes/_public.forbidden'
import { Route as AppConversationsCIdRouteImport } from './routes/_app.conversations.$cId'
import { Route as PublicAuthErrorRouteImport } from './routes/_public.auth.error'
import { Route as PublicAuthLogoutRouteImport } from './routes/_public.auth.logout'
import { Route as PublicShareTokenRouteImport } from './routes/_public.share.$token'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicBetaClosedRoute = PublicBetaClosedRouteImport.update({
  id: '/beta-closed',
  path: '/beta-closed',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForbiddenRoute = PublicForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => PublicRoute,
} as any)
const AppConversationsCIdRoute = AppConversationsCIdRouteImport.update({
  id: '/conversations/$cId',
  path: '/conversations/$cId',
  getParentRoute: () => AppRoute,
} as any)
const PublicAuthErrorRoute = PublicAuthErrorRouteImport.update({
  id: '/auth/error',
  path: '/auth/error',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAuthLogoutRoute = PublicAuthLogoutRouteImport.update({
  id: '/auth/logout',
  path: '/auth/logout',
  getParentRoute: () => PublicRoute,
} as any)
const PublicShareTokenRoute = PublicShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => PublicRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/beta-closed': typeof PublicBetaClosedRoute
  '/forbidden': typeof PublicForbiddenRoute
  '/conversations/$cId': typeof AppConversationsCIdRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/share/$token': typeof PublicShareTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/beta-closed': typeof PublicBetaClosedRoute
  '/forbidden': typeof PublicForbiddenRoute
  '/conversations/$cId': typeof AppConversationsCIdRoute
  '/auth/error': typeof PublicAuthErrorRoute
  '/auth/logout': typeof PublicAuthLogoutRoute
  '/share/$token': typeof PublicShareTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/beta-closed': typeof PublicBetaClosedRoute
  '/_public/forbidden': typeof PublicForbiddenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/conversations/$cId': typeof AppConversationsCIdRoute
  '/_public/auth/error': typeof PublicAuthErrorRoute
  '/_public/auth/logout': typeof PublicAuthLogoutRoute
  '/_public/share/$token': typeof PublicShareTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/beta-closed'
    | '/forbidden'
    | '/conversations/$cId'
    | '/auth/error'
    | '/auth/logout'
    | '/share/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/beta-closed'
    | '/forbidden'
    | '/conversations/$cId'
    | '/auth/error'
    | '/auth/logout'
    | '/share/$token'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_public/beta-closed'
    | '/_public/forbidden'
    | '/_app/'
    | '/_app/conversations/$cId'
    | '/_public/auth/error'
    | '/_public/auth/logout'
    | '/_public/share/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/beta-closed': {
      id: '/_public/beta-closed'
      path: '/beta-closed'
      fullPath: '/beta-closed'
      preLoaderRoute: typeof PublicBetaClosedRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forbidden': {
      id: '/_public/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof PublicForbiddenRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/conversations/$cId': {
      id: '/_app/conversations/$cId'
      path: '/conversations/$cId'
      fullPath: '/conversations/$cId'
      preLoaderRoute: typeof AppConversationsCIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/auth/error': {
      id: '/_public/auth/error'
      path: '/auth/error'
      fullPath: '/auth/error'
      preLoaderRoute: typeof PublicAuthErrorRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/auth/logout': {
      id: '/_public/auth/logout'
      path: '/auth/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof PublicAuthLogoutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/share/$token': {
      id: '/_public/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof PublicShareTokenRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppConversationsCIdRoute: typeof AppConversationsCIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppConversationsCIdRoute: AppConversationsCIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicBetaClosedRoute: typeof PublicBetaClosedRoute
  PublicForbiddenRoute: typeof PublicForbiddenRoute
  PublicAuthErrorRoute: typeof PublicAuthErrorRoute
  PublicAuthLogoutRoute: typeof PublicAuthLogoutRoute
  PublicShareTokenRoute: typeof PublicShareTokenRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicBetaClosedRoute: PublicBetaClosedRoute,
  PublicForbiddenRoute: PublicForbiddenRoute,
  PublicAuthErrorRoute: PublicAuthErrorRoute,
  PublicAuthLogoutRoute: PublicAuthLogoutRoute,
  PublicShareTokenRoute: PublicShareTokenRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
